import React from 'react'
import PropTypes from 'prop-types'
import { Tab } from 'component/base'
import { Custom } from 'component/pieces'

export const Shiiresaki = props => {
  const { multiple, setSelectedId, selectedId } = props

  return (
    <Tab
      panes={[
        {
          menuItem: '仕入先',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.Shiiresaki
                mode='dropdown'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
              />
            </Tab.Pane>
          ),
        },
      ]}
    />
  )
}

Shiiresaki.propTypes = {
  multiple: PropTypes.bool,
  setSelectedId: PropTypes.func,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Shiiresaki.defaultProps = {
  multiple: false,
  setSelectedId: () => {},
  selectedId: undefined,
}
